import { r as registerInstance } from './index-6e9159ae.js';
import { b as buildCustomEvent } from './event-utils-92b13243.js';
import { a as initializeEventName } from './initialization-utils-6efdca42.js';
import './utils-71996adb.js';
import './_commonjsHelpers-5ec8f9b7.js';

const AtomicExternal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * The CSS selector that identifies the `atomic-search-interface` component with which to initialize the external components.
     */
    this.selector = 'atomic-search-interface';
    this.selector = 'atomic-search-interface';
  }
  handleInitialization(event) {
    event.preventDefault();
    event.stopPropagation();
    this.interface.dispatchEvent(buildCustomEvent(initializeEventName, event.detail));
  }
  handleScrollToTop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.interface.dispatchEvent(buildCustomEvent('atomic/scrollToTop', event.detail));
  }
  get interface() {
    const element = document.querySelector(this.selector);
    if (!element) {
      throw new Error(`Cannot find interface element with selector "${this.selector}"`);
    }
    return element;
  }
};

export { AtomicExternal as atomic_external };

//# sourceMappingURL=atomic-external.entry.js.map